































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, userPrefPageSize, enumData } from '@/decorators';
import BulkSearchModal from '@/views/components/bulkSearchModal/index.vue';
import { Moment } from 'moment';

@Component({
  components: {
    BulkSearchModal,
  },
})
export default class TransportReturnOrderListPage extends Vue {
  /** 单号类型 */
  @enumData('Toms/ReturnOrder/CodeTypeEnum')
  private codeTypeEnum: TypeBase.EnumListItem[] = [];
  /** 状态类型 */
  @enumData('Toms/ReturnOrder/ReturnOrderStatusEnum')
  private returnOrderStatusEnum: TypeBase.EnumListItem[] = [];
  /** 日期类型 */
  @enumData('Toms/ReturnOrder/DateTypeEnum')
  private dateTypeEnum: TypeBase.EnumListItem[] = [];
  /**
   * 列表数据
   */
  protected dataList: TypeTransportReturnOrder.ListItem[]= [];
  /**
   * 表格列
   */
  protected columns: TypeBase.TableColumn[] = [];
  /**
   * 加载状态
   */
  protected loadingStatus: boolean = false;
  /**
   * 列表勾选
   */
  protected rowSelection: TypeBase.RowSelection = {};
  /** 仓库列表 */
  protected warehouseList: TypeTransportOrderCommon.WarehouseItem[] = [];
    /** 物流产品列表 */
  protected logisticsList: TypeTransportOrderCommon.LogisticsItem[] = [];
  /**
   * 搜索项
   */
  protected searchData: TypeTransportReturnOrder.SearchData = this.initSearchData();
  /**
   * 搜索条件缓存
   */
  protected searchParam: TypeTransportReturnOrder.SearchData = this.initSearchData();
  /**
   * 页码总数
   */
  protected total: number = 0;
  /**
   * 选中的sku列表
   */
  protected selectedIdList: string[] = [];
  /**
   * 批量查询的内容
   */
  protected docValue: string = '';
  /**
   *  时间范围
   */
  protected datetimeDefaultValue: Moment[] = this.$util.getDefaultTimeCondition(90);
  protected get showReturnOrderStatusEnum() {
    return [{value: this.$enum.common.StatusEnum.ALL, text: this.t('全部')}, ...this.returnOrderStatusEnum];
  }
  /**
   * 监听时间范围变化
   */
  @Watch('datetimeDefaultValue', { immediate: true })
  protected onDatetimeDefaultValueChange(arr: Moment[]): void {
    if (arr.length) {
      this.searchData.begin_time = this.$util.formatDateTime(arr[0]);
      this.searchData.end_time = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.begin_time = '';
      this.searchData.end_time = '';
    }
  }
  /**
   * 初始化搜索条件
   */
  @userPrefPageSize('transportReturnOrder')
  protected initSearchData(): TypeTransportReturnOrder.SearchData {
    return {
      code_list: [],
      code_type: this.$enum.transportOrder.ReturnCodeTypeEnum.CUSTOMER_ORDER_CODE,
      begin_time: '',
      end_time: '',
      order_return_status: this.$enum.common.StatusEnum.ALL,
      product_code: undefined,
      receipts_warehouse_code: undefined,
      time_type: this.$enum.transportOrder.ReturnOrderDateTypeEnum.SIGN_TIME,
      page_index: 1,
      page_size: 20,
    };
  }
  /**
   * @description: 获取物流产品列表
   * @param {TypeTransportOrderCommon} param 参数
   * @return {*}
   */
  protected async queryLogisticsList(param?: TypeTransportOrderCommon.ShippingMethodParam) {
    const {data} = await this.$api.transportOrder.queryLogisticsList(param);
    this.logisticsList = data;
  }
  /**
   * 获取库存列表
   */
  @loading('loadingStatus')
  protected async queryReturnOrderList(params: TypeTransportReturnOrder.SearchData): Promise<void> {
    const searchData = this.$util.deepCopy(params);
    if (searchData.order_return_status === this.$enum.common.StatusEnum.ALL) {
      searchData.order_return_status = undefined;
    }
    const { data } = await this.$api.transportOrder.queryReturnOrderList(searchData);
    const { list, total } = data;
    this.dataList = this.$util.createTableRowKey(list);
    this.searchParam = this.$util.deepCopy(searchData);
    this.total = total;
  }
  /**
   * 导出列表
   */
  protected async export(params: TypeTransportReturnOrder.SearchData): Promise<void> {
    const res = await this.$api.transportOrder.exportReturnOrder(params);
    if (res.code === 0) {
      this.$util.exportExcel(res.data);
    }
  }
  /**
   * 获取列表
   */
  protected getList(): void {
    this.rowSelection.selectedRowKeys = this.selectedIdList = [];
    const value = this.docValue.trim();
    const valueList = value ? value.split(',') : [];
    const params = this.$util.deepCopy(this.searchData);
    params.code_list = valueList;
    this.queryReturnOrderList(params);
  }

  /**
   * @description: 获取仓库列表
   * @return {*}
   */
  protected async queryWarehouseList() {
    const {data} = await this.$api.transportOrder.queryWarehouseList();
    this.warehouseList = data;
  }
  /**
   * 重置字段值
   */
  protected resetFieldValue(): void {
    this.docValue = '';
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition(90);
    this.searchData = this.initSearchData();
  }
  /**
   * @description: 切换订单状态
   * @return {*}
   */
  private handleOrderStatusChange() {
    this.getList();
  }
  /**
   * 双击批量查询
   */
  protected handleDblClick(): void {
    const bulkSearchRef = this.$refs.bulkSearchModal as BulkSearchModal;
    bulkSearchRef.modalVisible = true;
    bulkSearchRef.bulkListStr = this.docValue;
  }
  /**
   * 切换页码
   */
  protected handlePageChange(pageIndex: number, pageSize: number): void {
    this.searchData.page_index = pageIndex;
    this.searchData.page_size = pageSize;
    this.getList();
  }
  /**
   * 搜索按钮
   */
  protected handleSearch(): void {
    this.getList();
  }
  /**
   * 清空
   */
  protected handleReset(): void {
    this.resetFieldValue();
    this.$nextTick(() => {
      this.getList();
    });
  }
  /**
   * 导出全部
   */
  protected async handleExportAll(): Promise<void> {
    const params = this.$util.deepCopy(this.searchParam);
    delete params.page_index;
    delete params.page_size;
    this.export(params);
  }
  /**
   * 导出已选
   */
  protected async handleExportSelected(): Promise<void> {
    if (!this.selectedIdList.length) {
      this.$message.warn(this.tc(this.$config.exportSelectedEmptyTip));
      return;
    }
    const params: TypeTransportReturnOrder.SearchData = {
      id_list: this.selectedIdList,
    };
    this.export(params);
  }
  /**
   * 批量搜索
   */
  protected handleBulkFeedback(bulkKeywords: string): void {
    this.docValue = bulkKeywords;
  }
  protected created(): void {
    this.columns = [
      {
        title: this.t('客户单号'),
        disabled: true,
        dataIndex: 'refer_hawbcode',
        name: 'refer_hawbcode',
        isCopy: true,
      },
      {
        title: this.t('跟踪号'),
        dataIndex: 'server_hawbcode',
        name: 'server_hawbcode',
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('物流产品'),
        checked: true,
        name: 'product_code',
        dataIndex: 'product_code',
        width: 250,
      },
      {
        title: this.t('收件仓库'),
        checked: true,
        name: 'warehouse_code',
        scopedSlots: {
          customRender: 'warehouse_code',
        },
        width: 250,
      },
      {
        title: this.t('单据状态'),
        dataIndex: 'order_return_status_text',
        name: 'order_return_status_text',
      },
      {
        title: this.t('退货类型'),
        name: 'return_type_text',
        dataIndex: 'return_type_text',
      },
      {
        title: this.t('时间'),
        name: 'time',
        dataIndex: 'time',
        scopedSlots: {
            customRender: 'time',
        },
      },
    ];
    this.rowSelection = {
      selectedRowKeys: this.selectedIdList,
      onChange: (selectedRowKeys: string[]) => {
        this.rowSelection.selectedRowKeys = this.selectedIdList = selectedRowKeys;
      },
    };
    this.queryWarehouseList();
    this.queryLogisticsList();
    this.$nextTick(() => {
      this.getList();
    });
  }
}
